<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="m-container m-pt-40">
    <PageHeader
      icon="questionCircle"
      title="Hodnotenie"
      border
    />
    <FormSheet
      v-if="activity.type === 'support-conversation'"
    >
      <FormGroup
        label="Stotožnenie zamestnanca - poštový ťahák"
      >
        <InputOptionsSpectrum
          v-model="activity.rating.employee"
        />
      </FormGroup>
    </FormSheet>
    <FormSheet
      v-else-if="activity.type === 'manager-conversation'"
    >
      <FormGroup
        label="Stotožnenie vedúceho - poštový ťahák"
      >
        <InputOptionsSpectrum
          v-model="activity.rating.managerPostalPull"
        />
      </FormGroup>
      <FormGroup
        label="Stotožnenie vedúceho - manažérsky ťahák"
      >
        <InputOptionsSpectrum
          v-model="activity.rating.managerManagerialPull"
        />
      </FormGroup>
    </FormSheet>
    <div v-else>
      <p>Pre tento typ aktivity nie sú žiadne ďalšie otázky.</p>
    </div>
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader.vue';
import FormSheet from '@/components/FormSheet.vue';
import FormGroup from '@/components/FormGroup.vue';
import InputOptionsSpectrum from '@/components/InputOptionsSpectrum.vue';

defineProps({
  activity: {
    type: Object,
    required: true,
  },
});
</script>
